export default __webpack_public_path__ + "static/media/play-store.aa4011f2.webp";